/**
 * Description Field Type - Common
 *
 * Field-type configuration shared by the inline (inline/description.tsx) and
 * modal (modal/description.tsx) renderers.
 */

import type { FieldTypeConfig } from '../../components/types';
import { XL } from './columnWidths';

/** Re-export for backwards compatibility (source of truth is validation/fieldSchemas). */
export { defaultDescriptionMaxChar } from 'validation';

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Description field type configuration
 */
export const descriptionFieldType: FieldTypeConfig = {
  placeholder: (label: string) => `Enter ${label.toLowerCase()}...`,
  ...XL,
};
